import { useState, useEffect } from 'react';

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 200);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const buttonStyle = {
    marginTop: '1rem',
    backgroundColor: '#f72798',
    color: '#fff',
    textDecoration: 'none',
    padding: '0.75rem 1.5rem',
    borderRadius: '8px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s',
    position: 'fixed',
    bottom: '6rem',
    right: '6rem',
    border: 'none',
    cursor: 'pointer',
    zIndex: 1000,
  };

  return (
    isVisible && (
      <button
        onClick={scrollToTop}
        style={buttonStyle}
        onMouseOver={e => e.currentTarget.style.backgroundColor = '#c41c77'}
        onMouseOut={e => e.currentTarget.style.backgroundColor = '#f72798'}
        aria-label="Scroll to top"
      >
        Treug naar boven ↑
      </button>
    )
  );
}
